import React from 'react'
import { Import } from 'iconsax-react'

import Share from '../../../../icons/Share'
import MoreVerticalIcon from '../../../../icons/MoreVerticalIcon'
import ButtonMenu from '../../../ButtonMenu2'

import { downloadBlob } from '../../../../../utilities'
import useMediaCache from '@SonarCX/hooks/useMediaCache'
import useStyles from './styles'

const OPEN = 'Open File'
const DOWNLOAD = 'Download'
const FORWARD = 'Forward'
const DELETE = 'Delete File'

const Menu = ({ file, img, onOpenFileClick, isYours }) => {
  const [media, setMedia] = React.useState(null)
  const { getMedia, status, media: mediaCache } = useMediaCache()
  const classes = useStyles({ isYours, img })

  const options = React.useMemo(() => {
    let opts = [
      { name: OPEN },
      { name: DOWNLOAD },
      { name: FORWARD, disabled: true },
      { name: DELETE, disabled: true }
    ]

    return opts
  }, [])

  const handleDownloadClick = React.useCallback(async () => {
    if (file.id in mediaCache) {
      // Convert url from cache to blob
      fetch(mediaCache[file.id])
        .then(r => r.blob())
        .then(setMedia)
    } else if (!(file.id in status)) {
      getMedia(file.id)
    }
  }, [file, getMedia, mediaCache, status])

  // Download a file
  React.useEffect(() => {
    if (media) {
      downloadBlob(file?.filename, media)
    }
  }, [media, file])

  const handleMenuSelect = item => {
    if (item === OPEN) {
      onOpenFileClick()
    } else if (item === DOWNLOAD) {
      handleDownloadClick()
    } else if (item === FORWARD) {
    } else if (item === DELETE) {
    }
  }

  return (
    <div className={classes.root}>
      <Import
        className={classes.menuItem}
        size='24'
        color='white'
        onClick={handleDownloadClick}
      />
      <Share className={classes.menuItem} />
      <ButtonMenu
        options={options}
        className={classes.btnMenu}
        onSelect={handleMenuSelect}
      >
        <MoreVerticalIcon className={classes.menuItem} />
      </ButtonMenu>
    </div>
  )
}
export default Menu
